import { Card, Typography, Divider, Badge, FormGroup, MenuItem, Stack, TextField } from "@mui/material";
import { push } from "connected-react-router";
import { useListContext, useRecordContext } from "ra-core";
import { ChangeEvent, FC, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { RecPatch } from "@/dataProvider/tools";
import { DatabaseOwnershipStatsDto } from "@/gen/api/governance";
import { genUrlWithHashid } from "@/utils/hashid";
import { BasicInfoRow, BasicInfoPiece } from "../backups/BackupBasicInfoCard";
import { useTablesOwnershipContext } from "./useTablesOwnershipContext";


const DatabaseSelectionCard: FC = () => {
  const record: DatabaseOwnershipStatsDto|null = useRecordContext() as any

  const { data } = useListContext<DatabaseOwnershipStatsDto&RecPatch>()
  const databases = useMemo(() => Object.values(data || {}).sort((a, b) => (a.name || '') < (b.name || '') ? -1 : 1), [data])

  const [currDb, setCurrDb] = useState(record)
  const currDbRef = useRef(currDb)
  currDbRef.current = currDb

  useEffect(() => {
    if (currDbRef.current !== record) {
      setCurrDb(record)
    }
  }, [record])

  const { editsCount } = useTablesOwnershipContext()
  const dispatch = useDispatch()
  const handleTableChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (data) {
      if (editsCount > 0) {
        const discardContinue = window.confirm('You have unsaved ownership edits, do you wish to discard the changes and switch database?')
        if (!discardContinue) return
      }
      const database = data[e.target.value]
      setCurrDb(database)
      dispatch(push(genUrlWithHashid(`/governance/data-ownership/$0/show`, database?.databaseId || 0, database?.name)))
    }
  }
  return (
    <Card>
      <BasicInfoRow>
        <BasicInfoPiece>
          <Typography
            id="database-name"
            color="textPrimary"
            variant="h6"
          >
            Database
          </Typography>
          <FormGroup>
            <TextField select size="small" id='database-select'
              sx={{
                '& #database-select > div > span.MuiTypography-body2': {
                  maxWidth: 450, overflow: 'hidden', textOverflow: 'ellipsis'
                }
              }}
              value={currDb?.databaseId || ''}
              onChange={handleTableChange}
              SelectProps={{
                inputProps: {
                  labelId: 'database-name',
                }
              }}
            >
              {databases.map(t => (
                <MenuItem key={t.id} value={t.id}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    sx={{ width: '100%' }}
                  >
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{ mr: 'auto' }}
                    >
                      {t.name}
                    </Typography>
                    <Typography
                      component="span"
                      variant="caption"
                      sx={{ color: 'warning.main', mr: 2, '& span.total': { fontWeight: 700 } }}
                    >
                      <Badge 
                        color={"success" as any} 
                        badgeContent={t.ownedCount} 
                        showZero 
                        max={9999} 
                        sx={{ mr: 1.5 }}
                      />
                      <span className="total"> / {t.totalCount}</span>
                    </Typography>
                  </Stack>
                </MenuItem>
              ))}
            </TextField>
          </FormGroup>
        </BasicInfoPiece>
        <BasicInfoPiece>
          <Typography
            color="textPrimary"
            variant="h6"
          >
            Engine
          </Typography>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            {record?.engine || ''}
          </Typography>
        </BasicInfoPiece>
      </BasicInfoRow>
      <Divider />
      
    </Card>
  )
}

export default DatabaseSelectionCard;
